<template>
  <div class="ChecklistEditControl">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="oc-label-section">Enter Observation Date</label>
          <datepicker :clear-button="false" placeholder="Observation Date" v-model="selected_date" name="selected_date" :disabled-dates="{from:new Date()}"></datepicker>
          <ErrorList :errors="errors.datetime"></ErrorList>
        </div>
      </div>
      <div class="col-md-6">
        <br />
        <small>Note: to select historical date, click the date selector header (once to select month, twice to select year).</small>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <label class="oc-label-section">Choose a Location</label>
      </div>
      <div class="col-md-6" v-show="!addingLocation">
        <div class="form-group">
          <label><strong>Choose from previously used locations:</strong></label>
          <LocationSearch v-model="selected_location" :current_user="current_user" placeholder="Click to select or type to search" />
          <ErrorList :errors="errors.location"></ErrorList>
        </div>
        <div class="large-text-hr smaller">
          <hr />
          <strong>
            OR
          </strong>
        </div>
        <label><strong>Enter a new location from a map:</strong></label>
        <div class="row row-pullout" v-if="!addingLocation">
          <div class="col-6">
            <button v-on:click="addingLocation = true;" class="btn btn-block type--uppercase">Assign New Location</button>
          </div>
          <div class="col-6" v-if="checklist.location && showLocationEdit">
            <button v-on:click="editLocation" class="btn btn-block type--uppercase">Edit This Location</button>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <LocationAdd ref="locationAddRef" @locationAdded="locationAdded" @locationCanceled="locationCanceled" v-if="addingLocation" />
      </div>
    </div>
    <br />
    <div class="row" v-if="!addingLocation">
      <div class="col-md-7">
        <label class="oc-label-section">Check all that apply:</label>
        <div class="form-group">
          <div class="input-checkbox">
            <input type="checkbox" v-model="checklist.every_taxon_seen" />
            <label for="checkbox"></label>
          </div>
          <span>I am submitting a complete checklist of all the species I could identify
          </span>
          <ErrorList :errors="errors.every_taxon_seen"></ErrorList>
        </div>

        <div class="form-group">
            <div class="input-checkbox">
              <input type="checkbox" v-model="checklist.has_another_observer" />
              <label for="checkbox"></label>
            </div>
            <span>I am submitting for another observer</span>
            <div class="form-group" v-show="checklist.has_another_observer">
              <label><strong>Observer Name (optional)</strong></label>
              <input type="text" v-model="checklist.observer">
              <ErrorList :errors="errors.datetime"></ErrorList>
            </div>
            <ErrorList :errors="errors.observer"></ErrorList>
        </div>
        <div class="form-group">
          <div class="input-checkbox">
            <input type="checkbox" v-model="checklist.private" />
            <label for="checkbox"></label>
          </div>
          <span>make this checklist Private&nbsp; <button href="" class="btn btn-info btn-info-i" onclick="$('.alert-privacy').removeClass('hidden');$(this).hide();"><i class="fa fa-info-circle" ></i></button>
          </span>
          <ErrorList :errors="errors.private"></ErrorList>
        </div>
        <div class="alert alert-info alert-privacy hidden">
          <strong>Private Checklists</strong> - Checking this makes checklists, locations and individual records visible only to you and to vetters. Data may appear anonymously in some aggregated outputs such as regional lists.  It can be made public by editing the checklist later if desired.
        </div>

        <div>
          <label class="oc-label-section">Optional: Add your checklist to an authorized event or project: <i class="fa fa-info-circle" data-tooltip='You should only add your checklist to a project you are authorized to participate in. More information in Observations / Species Lists.'></i></label>
          <v-select v-if="projects" placeholder="No project(s) selected" label="name" :options="projects" v-model="selected_projects" multiple :filterable="false">
              <template slot="option" slot-scope="project">
                  {{project.name}}
              </template>
          </v-select>
          <div v-else>
            <strong><em>No projects for the selected observation date.</em></strong>
          </div>
        </div>
        <br />
      </div>
      <div class="col-md-6"></div>
    </div>
    <LocationEditModal 
      uniqueID="locationEditModal" 
      ref="locationEditModal" 
      @saved="locationSaved"
      >
      </LocationEditModal>
  </div>
</template>

<script>
export default {
  name: 'ChecklistEditControl',
  props: ['value', 'errors', 'current_user', 'showLocationEdit'],
  data: function(){
    return {
      checklist: this.value ? this.value : null,
      addingLocation: false,
      selected_location: null,
      selected_date: this.getSelectedDate(),
      projects:null,
      selected_projects: [],
    };
  },
  mounted: function(){
    this.init();
  },
  watch: {
    addingLocation: function () {
      this.$emit('addChanged', this.addingLocation);
    },
    value: function(){
      this.checklist = this.value;
      this.init();
    },
    checklist: function () {
      if (!this.selected_date) {
        this.selected_date = this.checklist.datetime;
      }
      this.$emit('input', this.checklist);
    },
    selected_date: function () {
      if (this.selected_date) {
        this.checklist.datetime = this.formatDate(this.selected_date);
      }
      else{
        this.checklist.datetime = null;
      }
      this.getProjects();
    },
    selected_location: function () {
      if (this.selected_location) {
        this.checklist.location = this.selected_location.id;
        this.$emit('locationChanged', this.selected_location);
      }
      else{
        this.checklist.location = null;
        this.$emit('locationChanged', null);
      }
    },
    selected_projects:function(){
      this.checklist.projects = [];
      for (var i = 0; i < this.selected_projects.length; i++) {
        this.checklist.projects.push(this.selected_projects[i].id);
      }
    },
  },
  methods:{
    locationSaved: function(new_location_id){
      this.setLocation(new_location_id);
    },
    editLocation: function(){
      this.$refs.locationEditModal.showLocation(this.checklist.location)
    },
    init:function(){
      if (this.checklist) {
        if (this.checklist.location) {
          this.setLocation(this.checklist.location);
        }
        if (this.checklist.observer) {
          this.checklist.has_another_observer = true;
        }
        if (this.checklist.datetime) {
          this.getProjects();
        }
      }
    },
    getProjects:function(){
      var self = this;
      this.API({
        endpoint: 'projects',
        querystring: '&date=' + this.getAPIFomratedSelectedDate(),
        funcThen: function(response){
          self.projects = response.data.projects;
          if (self.checklist) {
            var tmp_projects = [];
            for (var i = 0; i < self.projects.length; i++) {
              if (self.checklist.projects && self.checklist.projects.includes(self.projects[i].id)) {
                tmp_projects.push(self.projects[i]);
              }
            }
            self.selected_projects = tmp_projects;
          }
          else{
            self.selected_projects = [];
          }
        },
      });
    },
    getAPIFomratedSelectedDate: function(){
      if (this.value && this.value.datetime) {
        var dparts = this.getDateParts();
        return dparts[0] + "-" + dparts[1] + "-" + dparts[2];
      }
      return null;
    },
    getSelectedDate: function (){
      if (this.value && this.value.datetime) {
        var dparts = this.getDateParts();
        return new Date(dparts[0],parseInt(dparts[1]) - 1,dparts[2]);
      }
      return null;
    },
    getDateParts:function(){
      return this.value.datetime.split('T')[0].split('-');
    },
    setLocation:function(location_id){
      var self = this;
      this.API({
        endpoint: 'locations/' + location_id,
        funcThen: function(response){
          self.locationAdded(response.data.location);
        },
      });
    },
    locationCanceled: function(){
      this.addingLocation = false;
    },
    locationAdded: function(location){
      this.addingLocation = false;
      if (location.display_name == "") {
        location.display_name = location.name;
      }
      this.locations = [location];
      this.selected_location = this.locations[0];
    },
    setDate: function(date){
      this.selected_date = date;
    },
    setCoordinates: function(lat, lng, locationName, obscured){
      this.addingLocation = true;
      this.$nextTick(function(){
        this.$refs.locationAddRef.setCoordinates(lat, lng, locationName, obscured);
      });
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/ChecklistEditControl.vue